import React, { useState, useRef, useEffect } from "react";

const QRScannerInput = ({ onScan }) => {
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  // Auto-focus the input when the component mounts
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      // When Enter is pressed, send the scanned code to the API (or a callback)
      onScan(inputValue);
      setInputValue("");
      e.preventDefault();
    }
  };

  return (
    <input
      ref={inputRef}
      type="text"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      onKeyDown={handleKeyDown}
      // Hide the input visually while keeping it in the DOM
      style={{
        position: "absolute",
        opacity: 0,
        pointerEvents: "none",
      }}
    />
  );
};

export default QRScannerInput;
